<template>
  <div class="filters-container">
    <el-row :gutter="24">
      <custom-select
        v-model="cylinderFilters.CilindroTipo"
        :label="'Tipo cilindro'"
        :spanColumn="3"
        :settings="{
          placeholder: 'Seleccionar cilindro',
          options: cilindroTipoList,
        }"
      >
      </custom-select>
      <custom-input-number
        v-model="cylinderFilters.CantidadCilindros"
        :label="'Cantidad de cilindros'"
        :spanColumn="3"
        :settings="{
          placeholder: 'Cantidad de cilindros',
          inputClass: 'ancho_total',
          min: 0,
          precision: 0,
          step: 0.01,
          controls: false,
        }"
      ></custom-input-number>
      <custom-input-number
        v-model="cylinderFilters.CantidadMagneticos"
        :label="'Cantidad de magneticos'"
        :spanColumn="3"
        :settings="{
          placeholder: 'Cantidad de magneticos',
          inputClass: 'ancho_total',
          min: 0,
          precision: 0,
          step: 0.01,
          controls: false,
        }"
      ></custom-input-number>
      <custom-input-number
        v-model="cylinderFilters.CantidadAlmasStamping"
        :label="'Cantidad de almas de stamping'"
        :spanColumn="3"
        :settings="{
          placeholder: 'Cantidad de almas de stamping',
          inputClass: 'ancho_total',
          min: 0,
          precision: 0,
          step: 0.01,
          controls: false,
        }"
      ></custom-input-number>
      <custom-input-number
        v-model="cylinderFilters.CantidadCilindrosRelieveEnLinea"
        :label="'Cantidad de cilindros de relieve en línea'"
        :spanColumn="3"
        :settings="{
          placeholder: 'Cantidad de cilindros de relieve',
          inputClass: 'ancho_total',
          min: 0,
          precision: 0,
          step: 0.01,
          controls: false,
        }"
      ></custom-input-number>
      <el-col :span="2">
        <div class="custom-label">Activo</div>
        <el-switch v-model="cylinderFilters.Activo" />
      </el-col>
      <el-col
        :span="3"
        class="button-container"
      >
        <el-button
          type="primary"
          size="default"
          @click="filtrarCilindro"
          >Filtrar</el-button
        >
        <el-popover
          placement="right"
          :width="40"
          effect="dark"
          trigger="hover"
          content="Limpiar filtros"
        >
          <template #reference>
            <el-button
              type="danger"
              size="default"
              :icon="IconDelete"
              @click="LimpiarFiltros"
            ></el-button>
          </template>
        </el-popover>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import CustomSelect from '@/shared/components/custom_select.vue';
import { useCilindroTipoStore } from '@/stores/cilindro-tipo/cilindro-tipo';
import { useCylinderStore } from '../stores/cylinders_store.js';
import IconDelete from '~icons/mdi/delete';

const cilindroTipoStore = useCilindroTipoStore();
const cylinderStore = useCylinderStore();
const { cilindroTipoList } = storeToRefs(cilindroTipoStore);
const { emptyList, setPage, findAllDesarrolloCilindroTipoHTTP, resetFilter } = cylinderStore;
const { cylinderFilters } = storeToRefs(cylinderStore);

const LimpiarFiltros = () => {
  setPage(1);
  emptyList();
  resetFilter();
  findAllDesarrolloCilindroTipoHTTP();
};

const filtrarCilindro = () => {
  setPage(1);
  emptyList();
  findAllDesarrolloCilindroTipoHTTP();
};
</script>

<style scoped>
.filters-container {
  background-color: white;
  border: 3px solid lightgray;
  padding: 20px;
}
.custom-label {
  font-weight: 700;
  color: #111;
}
.button-container {
  /* Estilo específico para el contenedor del botón */
  margin-top: auto; /* Empuja el contenido hacia abajo, ocupando la parte inferior */
}
.margin-row {
  margin-top: 1%;
}
</style>
